export const dateAndYearMixin = {
    methods: {
        validateDates(supervisors, application) {
            var days = 0;
            supervisors.forEach((val,idx) => {
                if(val.workDate.startDate !== '' && val.workDate.endDate != '') {
                    var sDate = new Date(val.workDate.startDate)
                    var eDate = new Date(val.workDate.endDate)
                    var diffDays = parseInt((eDate - sDate)/(1000 * 60 * 60 * 24))
                    days = days + 1 + diffDays // There is difference in count due to time zone.
                }
            })

            if(days <= 30) {
                if(application)
                    application.guestWorkDay = days;
                return true;
            }
            else
                return false;
        },
        validateYear(supervisors) {
            var now = new Date(Date.now())
            var yr = new Date(supervisors[0].workDate.startDate).getFullYear()
            var isSame = supervisors.every(d => (new Date(d.workDate.startDate).getFullYear() === yr
                && new Date(d.workDate.endDate).getFullYear() === yr) || (!d.workDate.startDate || !d.workDate.endDate))
            //this will produce Nov 1 due to conversion
            var isPastNov = now > new Date(now.getFullYear() +'-'+'11'+'-'+'02')
            return isSame && ((yr === now.getFullYear()) || (isPastNov && yr === (now.getFullYear()+1)))
        }

    }
}